import React, { useRef, useCallback, useState } from 'react';

import Typography, { TypographyProps, } from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import config from 'cityads-v3/config';

import classes from './CopyText.scss';
import { useTranslation } from 'react-i18next';

type CopyTextProps = TypographyProps & {
  component?: string,
  copyText: string
};

const CopyText: React.FC<CopyTextProps> = function CopyText({ children, copyText, ...rest }) {
  const { t } = useTranslation(['main'])
  const inputRef = useRef<HTMLInputElement>(null);
  const [notifyOpen, setNotifyOpen] = useState<boolean>(false);

  const handleCopy = useCallback(() => {
    inputRef.current.select();
    document.execCommand('copy');
    setNotifyOpen(true)
  }, [])

  const handleCloseNotify = useCallback(() => {
    setNotifyOpen(false)
  }, [])

  return (
    <>
      <Typography
        {...rest}
        classes={{ root: classes.typography }}
        onClick={handleCopy}
      >
        {children}
        <input className={classes.copyInput} ref={inputRef} value={copyText} readOnly />
      </Typography>
      <Snackbar open={notifyOpen} autoHideDuration={config.SNACKBAR_AUTOHIDE_DURATION} onClose={handleCloseNotify}>
        <Alert onClose={handleCloseNotify} severity="success">
          {t('copiedToClipboard')}
        </Alert>
      </Snackbar>
    </>
  )
}

export default CopyText
